import script from "./LicenseWindowDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenseWindowDetails.vue?vue&type=script&setup=true&lang=js"

import "./LicenseWindowDetails.vue?vue&type=style&index=0&id=772613ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-772613ae"]])

export default __exports__